<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item"><router-link to="/kr/mypage/result/out">외래진료 내역</router-link></li>
            <!-- <li class="tab-menu__item"><router-link to="/kr/mypage/result/drug">약 처방 내역</router-link></li> -->
            <li class="tab-menu__item active"><router-link to="/kr/mypage/result/check">검사결과</router-link></li>
        </ul>
    </div>
    <div class="info">
        <h3 class="bullet01">검사정보</h3>
        <div class="table column type03">
            <table>
                <colgroup>
                    <col style="width:20%;">
                    <col style="width:30%;">
                    <col style="width:20%;">
                    <col style="width:30%;">
                </colgroup>
                <tbody>
                    <tr>
                        <th>검사일자</th>
                        <td class="left">2024-07-29</td>
                        <th>검사명</th>
                        <td class="left">CRP (Quant)</td>
                    </tr>
                    <tr>
                        <th>결과</th>
                        <td class="left">1.12 (mg/L)</td>
                        <th>참고치</th>
                        <td class="left">0.0~5.0</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="info">
        <div class="blood-chart">
            <div>
                <Line class="blood-chart-inner" :data="filteredChartData" :options="chartOptions"  />
            </div>
        </div>
    </div>
    <div class="info">
        <div class="table">
            <table>
                <colgroup>
                    <col style="width:50%;">
                    <col style="width:50%;">
                </colgroup>
                <thead>
                    <tr>
                        <th>날짜</th>
                        <th>수치</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>2024-09-03</td>
                        <td>1.12 (mg/L)</td>
                    </tr>
                    <tr>
                        <td>2024-07-02</td>
                        <td>1.12 (mg/L)</td>
                    </tr>
                    <tr>
                        <td>2024-07-02</td>
                        <td>1.12 (mg/L)</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="botton-wrap">
        <router-link to="/kr/mypage/result/check" class="sub-button c-gray">목록</router-link>
    </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale, ChartDataLabels);

export default {
    components: {
    Line,
    },
    data() {
        return {
            isMobile: false, // 모바일 여부를 체크할 변수
            chartData: {
                labels: ['2024-02-04', '2024-06-20', '2024-07-29'],
                datasets: [
                    {
                    label: 'HealthInfo 1',
                    backgroundColor: 'transparent',
                    borderColor: '#09847d',
                    pointBackgroundColor: '#09847d',
                    data: [3.42, 6.84, 13.67,],
                    fill: false,
                    tension: 0.4,
                    borderWidth: 1,
                    datalabels: {
                        anchor: 'end',
                        align: (context) => {
                        return 'end'; 
                        },
                        formatter: (value) => value,
                        color: 'white',
                        backgroundColor: '#09847d',
                        borderRadius: 3,
                        padding: {
                        top: 4,
                        bottom: 2,
                        left: 7,
                        right: 7,
                        },
                        width: 200,
                        font: {
                        size: 16,
                        weight: '700',
                        },
                    },
                    },
                ],
            },
            chartOptions: this.getChartOptions(), // 초기 차트 옵션
            checkList: [],
        };
    },
    mounted() {
        this.getCheckDetail()
        this.updateMobileStatus(); // 초기 모바일 상태 확인
        window.addEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 등록
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 제거
    },
    methods: {
        getCheckDetail() {
            const searchParam = {}

            searchParam.IN_SEL_TYPE = this.$route.query.inSelType
            searchParam.IN_CODE = this.$route.query.spcmNo
            searchParam.IN_CODE2 = this.$route.query.exmCtgCd

            this.axios.get(this.api.mypage.checkDetail, {
                params: searchParam
            }).then(res => {
                this.checkList = res.data
                if(!Array.isArray(this.checkList)) this.checkList = [this.checkList]
                console.log(this.checkList)
            })
        },
        updateMobileStatus() {
            this.isMobile = window.innerWidth < 768; // 모바일 기준: 768px 이하
            this.chartOptions = this.getChartOptions(); // 차트 옵션 업데이트
        },
        getChartOptions() {
            if (this.isMobile) {
            return {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                padding: {
                    top: 40,
                    right: 30, // 모바일에서의 오른쪽 패딩
                    bottom: 0,
                    left: 0,
                },
                },
                scales: {
                y: {
                    title: {
                    display: true,
                    text: 'none',
                    padding: {
                        top: -0,
                        right: -40,
                        left: 10,
                    },
                    font: {
                        size: 0,
                        weight: '400',
                    },
                    },
                    ticks: {
                    padding: 18, // 모바일에서의 ticks 패딩
                    font: {
                        size: 14,
                        weight: '400',
                    },
                    },
                    grid: {
                    display: true,
                    drawBorder: false,
                    },
                },
                x: {
                    ticks: {
                    padding: 10, // 모바일에서의 x축 ticks 패딩
                    font: {
                        size: 16,
                        weight: '500',
                    },
                    },
                    grid: {
                    display: false,
                    drawBorder: false,
                    },
                },
                },
                plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: false,
                },
                datalabels: {
                    display: true,
                },
                },
                elements: {
                point: {
                    radius: 3, // 모바일에서의 포인트 크기
                    hoverRadius: 3,
                },
                },
            };
            } else {
            return {
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                padding: {
                    top: 0,
                    right: 115, // PC에서의 오른쪽 패딩
                    bottom: 0,
                    left: 0,
                },
                },
                scales: {
                y: {
                    title: {
                    display: true,
                    text: 'none',
                    padding: {
                        top: -10,
                        right: -100,
                    },
                    font: {
                        size: 0,
                        weight: '400',
                    },
                    },
                    ticks: {
                    padding: 50, // PC에서의 ticks 패딩
                    font: {
                        size: 16,
                        weight: '400',
                    },
                    },
                    grid: {
                    display: true,
                    drawBorder: false,
                    },
                },
                x: {
                    ticks: {
                    padding: 20, // PC에서의 x축 ticks 패딩
                    font: {
                        size: 18,
                        weight: 'bold',
                    },
                    },
                    grid: {
                    display: false,
                    drawBorder: false,
                    },
                },
                },
                plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    enabled: false,
                },
                datalabels: {
                    display: true,
                },
                },
                elements: {
                point: {
                    radius: 5, // PC에서의 포인트 크기
                    hoverRadius: 5,
                },
                },
            };
            }
        },
    },
    computed: {
        filteredChartData() {
            return this.chartData;
        },
    },
};
</script>


<style scoped></style>